import { Injectable } from '@angular/core';
import { AbstractFindOneByIdService } from '../../../../../core/service/v2/service/findone/abstractFindOneById.service';
import {LovValue} from '../../api/model/LovValue.model';
import {LovValueRepository} from './ngrx/lovValue.repository';
import {LovValueDataServiceAdapter} from './ngrx/lovValueDataService.adapter';
import {LovValueCacheService} from "../../api/service/lovValueCache.service";

@Injectable()
export class LovValueFindOneService extends AbstractFindOneByIdService<LovValue, LovValue> {

    constructor(repository: LovValueRepository,
                dataServiceAdapter: LovValueDataServiceAdapter,
                private lovValueCacheService: LovValueCacheService) {
        super(repository, dataServiceAdapter);
    }

    protected onEntityLoaded(entity: LovValue) {
        if (entity) {
            this.lovValueCacheService.putInCache(entity.summary);
        }
    }
}
